import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { selectUserRole } from 'state/User/userSlice';
import { ROLE_PERMISSIONS_MAP, Permission } from 'utils/permissions';
import { USER_ROLES } from 'utils/constants';

const usePermissions = (permissions: Permission[]): boolean[] => {
  const userRole = useSelector(selectUserRole);
  const { newIntermediaryRole = false } = useFlags();

  return useMemo(() => {
    const hasPermission = (permission: Permission): boolean => {
      if (!userRole) return false;

      // Admins have all permissions by default
      if (userRole === USER_ROLES.ADMIN) {
        return true;
      }

      // If the new intermediary role is not enabled, return false
      if (!newIntermediaryRole) {
        return false;
      }

      const rolePermissions = ROLE_PERMISSIONS_MAP[userRole];
      return !!rolePermissions && rolePermissions.includes(permission);
    };

    return permissions.map(hasPermission);
  }, [userRole, newIntermediaryRole, permissions]);
};

export default usePermissions;
